(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  class StickyATCHeader extends HTMLElement {
    connectedCallback() {
      this.headerInitialized = false;
      this.prevScrollY = window.scrollY;
      this.isScrollingDown = false; // track scroll direction
      this.isOutOfView = false;
      this.initStickyBehavior();
      this.setupVariantListener();
      this.setupScrollDirectionListener();
    }

    initStickyBehavior() {
      // Find the actual Add to Cart button in the main product form
      const mainAddToCartButton = document.querySelector('.product-details add-to-cart-component button[name="add"]');

      if (!mainAddToCartButton) {
        // Fallback to buy buttons section if button not found
        const buyButtonsSection = document.querySelector('.product-details [data-type="add-to-cart-form"]');
        if (buyButtonsSection) {
          this.observeElement(buyButtonsSection);
        }
        return;
      }

      this.observeElement(mainAddToCartButton);
    }

    observeElement(element) {
      let hasInitializedVisibility = false;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // The element for sticky visibility is only handled if completely out of view (i.e. bottom of screen above top of ATC)
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              this.isOutOfView = false;
              this.classList.remove('is-visible');
              hasInitializedVisibility = true;
            } else {
              this.isOutOfView = true;
              // Only show sticky ATC header if both: 1) user scrolled down, and 2) the ATC is out of view, and 3) initial intersect has occurred
              this.updateStickyHeaderVisibility(hasInitializedVisibility);
            }
          });
        },
        {
          threshold: 0,
          rootMargin: '0px'
        }
      );

      observer.observe(element);
    }

    setupScrollDirectionListener() {
      this.prevScrollY = window.scrollY;
      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;
        const scrollDown = currentScrollY > this.prevScrollY;
        this.isScrollingDown = scrollDown;
        this.prevScrollY = currentScrollY;
        // If currently out of view, decide sticky visibility as scrolls happen
        if (this.isOutOfView) {
          this.updateStickyHeaderVisibility(true);
        } else {
          // If ATC is in view, always hide sticky
          this.classList.remove('is-visible');
        }
      });
    }

    updateStickyHeaderVisibility(hasInitializedVisibility) {
      // Show sticky header ONLY if scrolling down AND element is out of view and atc has been seen
      if (hasInitializedVisibility && this.isOutOfView && this.isScrollingDown) {
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }

    setupVariantListener() {
      document.addEventListener('variant:change', (event) => {
        const variantInput = this.querySelector('input[name="id"]');
        if (variantInput && event.detail.variant) {
          variantInput.value = event.detail.variant.id;

          const addToCartButton = this.querySelector('button[name="add"]');
          if (addToCartButton) {
            if (event.detail.variant.available) {
              addToCartButton.removeAttribute('disabled');
            } else {
              addToCartButton.setAttribute('disabled', 'disabled');
            }
          }
        }
      });
    }
  }

  if (!customElements.get('sticky-atc-header')) {
    customElements.define('sticky-atc-header', StickyATCHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
